import React, { useRef, useState } from "react";
import { Upload, X } from "lucide-react";
import { Progress } from "../ui/progress";
import { uploadChunked, formatApiError, formatSize } from "../resources/resourceUtils";

const ACCEPT = { pdf: "application/pdf,.pdf", audio: "audio/*,.mp3,.m4a,.wav", image: "image/jpeg,image/png,image/webp,image/gif" };

export const FileField = ({ kind, value, onChange, label, testid }) => {
    const ref = useRef(null);
    const [progress, setProgress] = useState(null);
    const [error, setError] = useState("");

    const pick = async (e) => {
        const file = e.target.files?.[0];
        e.target.value = "";
        if (!file) return;
        setError("");
        setProgress(0);
        try {
            onChange(await uploadChunked(file, kind, setProgress));
        } catch (err) {
            setError(formatApiError(err));
        } finally {
            setProgress(null);
        }
    };

    return (
        <div data-testid={testid}>
            <span className="block text-[15px] mb-2" style={{ color: "#4A4A30" }}>{label}</span>
            {value ? (
                <div className="flex items-center justify-between gap-3 rounded-xl border px-4 py-3" style={{ borderColor: "#E8E4DA" }}>
                    <span className="text-[15px] truncate" data-testid={`${testid}-name`}>
                        {value.filename} <span style={{ color: "#7D7D68" }}>{formatSize(value.size)}</span>
                    </span>
                    <button type="button" onClick={() => onChange(null)} className="p-1" aria-label="Remove file" data-testid={`${testid}-remove`}>
                        <X size={16} />
                    </button>
                </div>
            ) : (
                <button
                    type="button"
                    onClick={() => ref.current?.click()}
                    disabled={progress !== null}
                    className="w-full flex items-center justify-center gap-2 rounded-xl border border-dashed px-4 py-5 text-[15px] disabled:opacity-60"
                    style={{ borderColor: "#B8B39F", color: "#4A4A30" }}
                    data-testid={`${testid}-button`}
                >
                    <Upload size={16} strokeWidth={1.6} />
                    {progress !== null ? `Uploading... ${progress}%` : "Choose a file"}
                </button>
            )}
            {progress !== null && <Progress value={progress} className="mt-3 h-1.5" />}
            {error && <p role="alert" className="mt-2 text-[14px]" style={{ color: "#9A4557" }} data-testid={`${testid}-error`}>{error}</p>}
            <input ref={ref} type="file" accept={ACCEPT[kind]} onChange={pick} className="hidden" data-testid={`${testid}-input`} />
        </div>
    );
};
